module.exports = __webpack_public_path__ + "images/a-markov-7d5d68.jpg";